import api from './api'

import type {
  PhraseGroup,
  Phrase,
  CreatePhraseGroupRequest,
  UpdatePhraseGroupRequest,
  CreatePhraseRequest,
  UpdatePhraseRequest
} from '@/models/phrases'

class PhrasesApiService {
  static getInstance(): PhrasesApiService {
    return this.instance || (this.instance = new this())
  }

  private static instance: PhrasesApiService

  private baseUrl = '/samples/phrases'

  private constructor() {
    // empty for linter
  }

  getPhrasesGroups() {
    const url = `${this.baseUrl}?expand=count`
    return api.get<PhraseGroup[]>(url)
  }

  createPhraseGroup(data: CreatePhraseGroupRequest) {
    return api.post<PhraseGroup>(this.baseUrl, data)
  }

  updatePhraseGroup(id: string, data: UpdatePhraseGroupRequest) {
    return api.post<void>(`${this.baseUrl}/${id}`, data)
  }

  deletePhraseGroup(id: string) {
    return api.delete<void>(`${this.baseUrl}/${id}`)
  }

  getPhrasesByGroup(groupId: string) {
    const url = `${this.baseUrl}/${groupId}`
    return api.get<Phrase[]>(url)
  }
  
  createPhrase(groupId: string, data: CreatePhraseRequest) {
    return api.post<Phrase>(`${this.baseUrl}/${groupId}/create`, data)
  }

  updatePhrase(groupId: string, id: string, data: UpdatePhraseRequest) {
    return api.post<void>(`${this.baseUrl}/${groupId}/${id}`, data)
  }

  deletePhrase(groupId: string, id: string) {
    return api.delete<void>(`${this.baseUrl}/${groupId}/${id}`)
  }

  publishPhrase(groupId: string, id: string) {
    return api.get<void>(`${this.baseUrl}/${groupId}/${id}/publish`)
  }

  unpublishPhrase(groupId: string, id: string) {
    return api.get<void>(`${this.baseUrl}/${groupId}/${id}/unpublish`)
  }
}

export default PhrasesApiService.getInstance()
